import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import * as React from "react";
import {Box, Card, Grid, Tab, Tabs} from "@mui/material";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import {useState} from "react";
import HealthInformation from "./healthInformation";
import TabPanel from "../../components/TabPanel";
import Rules from "./rules";
import PaymentDescription from "./paymentDescription";
import FollowUpDescription from "./followUpDescription";

export default function Settings(){
    const [tab, setTab] = useState(sessionStorage.getItem('settingTab') !== null ? JSON.parse(sessionStorage.getItem('settingTab')) : 0);

    const handleChangeTab = (event, newValue) => {
        setTab(newValue);
        sessionStorage.setItem('settingTab', newValue)
    };
    return(
        <DashboardLayout>
            <MDBox pt={2} mb={6}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <MDTypography variant="h6" color="white">
                                    تنظیمات
                                </MDTypography>
                                <DashboardNavbar />
                            </MDBox>
                            <MDBox pt={6} px={2}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={tab} onChange={handleChangeTab} textColor="primary" indicatorColor="primary">
                                        <Tab value={0} label="اطلاعات سلامت" className='font-bold' />
                                        <Tab value={1} label="قوانین نوبت دهی" className='font-bold' />
                                        <Tab value={2} label="توضیحات تایید پرداخت" className='font-bold' />
                                        <Tab value={3} label="توضیحات پیگیری" className='font-bold' />
                                    </Tabs>
                                    <TabPanel value={tab} index={0}>
                                        <HealthInformation/>
                                    </TabPanel>
                                    <TabPanel value={tab} index={1}>
                                        <Rules/>
                                    </TabPanel>
                                    <TabPanel value={tab} index={2}>
                                        <PaymentDescription/>
                                    </TabPanel>
                                    <TabPanel value={tab} index={3}>
                                        <FollowUpDescription/>
                                    </TabPanel>
                                </Box>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}
